<template>

  <Loading :show="showLoading" />

  <!--   Big container   -->
  <div class="container">
    <div class="row">

      <div class="col-sm-8 col-sm-offset-2">

        <div style="text-align: center; margin-top: 2rem;">
          <a href="javascript:void(0);" @click="abrirSiteCliente()" >
            <img src="assets/img/urbs/logo.png" /> 
          </a>
        </div>
        <!--      Wizard container        -->
        <div class="wizard-container" style="padding-top: 25px;">
          <div class="card wizard-card" data-color="blue" id="wizard" style="display: block;">
            <form action="" method="" novalidate="novalidate">
              
              <!-- ==================== -->
              <!-- TITULO E DESCRIÇÃO   -->
              <!-- ==================== -->
              <div class="wizard-header">
                <h3 class="wizard-title">Pagamento</h3>
                <h5>Insira suas informações para concluir o pagamento.</h5>
              </div>

              <!-- ================ -->
              <!-- BARRA DE MENU    -->
              <!-- ================ -->
              <div v-on:click.stop class="wizard-navigation">
                <ul class="nav nav-pills">
                  <li class="active" style="width: 33.3333%">
                    <a href="#details" data-toggle="tab" aria-expanded="true">Dados pagamento</a>
                  </li>
                  <li style="width: 33.3333%" class="">
                    <a href="#captain" data-toggle="tab" aria-expanded="false">Identificação</a>
                  </li>
                  <li style="width: 33.3333%" class="">
                    <a href="#description" data-toggle="tab" aria-expanded="false">Resumo</a>
                  </li>
                </ul>
                <div class="moving-tab" style="width: 250px; transform: translate3d(-8px, 0px, 0px); transition: transform 0s ease 0s;">
                </div>
              </div>

              <div class="tab-content" style="padding: 35px;">
              
              <!-- ================= -->
              <!-- PAGAMENTO: INICIO -->
              <!-- ================= -->
              <div class="tab-pane active" id="details">
                <div class="row">

                    <!-- ======================= -->
                    <!-- PAGAMENTO: TITULO       -->
                    <!-- ======================= -->
                    <div class="col-sm-12">
                      <h4 class="info-text">
                        <strong>Dados titular cartão</strong>
                      </h4>
                    </div>
                    
                    <!-- ================================================= -->
                    <!-- PAGAMENTO: NUMERO, VALIDADE E CODIGO DE SEGURANÇA  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-5">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">Número do cartão</label>
                            <input name="pNumero" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'#### #### #### ####'" 
                                   v-model="pgnumerocartao" 
                                   v-on:input="getCardBrand()" 
                                   required 
                                   aria-invalid="true" />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgnumerocartao">{{msgerror.pgnumerocartao}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">Validade</label>
                            <input name="pValidade" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                  v-maska="'##/##'" 
                                  v-model="pgvalidadecartao"
                                  required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgvalidadecartao">{{msgerror.pgvalidadecartao}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">CVV</label>
                            <input name="pCvv" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'###'" 
                                   v-model="pgcvvcartao" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgcvvcartao">{{msgerror.pgcvvcartao}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- ================================== -->
                    <!-- PAGAMENTO: NOME E DATA NASCIMENTO  -->
                    <!-- ================================== -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">Nome completo</label>
                            <input name="pNomeCompleto" 
                                   type="text" 
                                   autocomplete="nope"
                                   class="form-control"
                                   v-model="pgnomecompleto" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgnomecompleto">{{msgerror.pgnomecompleto}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">Data nascimento</label>
                            <input name="pDtNascimento" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'##/##/####'"
                                   v-model="pgdatanascimento"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgdatanascimento">{{msgerror.pgdatanascimento}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- ============================== -->
                    <!-- PAGAMENTO: CPF E TELEFONE      -->
                    <!-- ============================== -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">CPF</label>
                            <input name="pCpf" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'###.###.###-##'"
                                   v-model="pgcpf" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgcpf">{{msgerror.pgcpf}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">Telefone</label>
                            <input name="pTelefone" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'(##) # #### ####'"
                                   v-model="pgtelefone" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgtelefone">{{msgerror.pgtelefone}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- ============================== -->
                    <!-- PAGAMENTO: CEP E PARCELAS      -->
                    <!-- ============================== -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">CEP</label>
                            <input name="pCep" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'#####-###'"
                                   v-model="pgcep" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgcep">{{msgerror.pgcep}}<br></span>
                            <a href="javascript:void(0);" @Click="abrirSiteCorreio()" style="font-size: 12px; color: #5aaac9;">Não sei meu cep </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating ">
                            <label class="control-label">Parcelas</label>

                              <!-- <select v-if="parcelasLista.length === 0" class="form-control" @click="validShowinstallment()"> -->
                              <select class="form-control">
                                <option>1x de R$ {{pedidoResponse.valorTotal.toFixed(2)}} (sem juros)</option>
                              </select>
                              <!-- </select> -->

                              <!--
                              <select v-else v-model="parcelas"  class="form-control"  @click="validShowinstallment()">
                                    <option v-for="(parcela, index) in parcelasLista" :key="`${index}`" 
                                            :value="parcela">
                                            
                                            {{parcela.quantity}}x de R$ {{parcela.installmentAmount}} {{parcela.interestFree ? '(sem juros)' : '(com juros)' }}
                                    </option>
                              </select>
                              -->
                              <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ====================== -->
                <!-- IDENTIFICACAO: INICIO  -->
                <!-- ====================== -->
                <div class="tab-pane" id="captain">
                  <div class="row">

                    <!-- ======================= -->
                    <!-- IDENTIFICACAO: TITULO       -->
                    <!-- ======================= -->
                    <div class="col-sm-12">
                      <h4 class="info-text">
                        <strong>Dados comprador</strong>
                      </h4>
                    </div>
                    
                    <!-- ================================================= -->
                    <!-- IDENTIFICACAO: NOME, CPF E DATA NASCIMENTO  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-5">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="control-label">Nome completo</label>
                            <input name="iNome" 
                                   type="text" 
                                   class="form-control"
                                   autocomplete="nope" 
                                   v-model="cpnomecompleto"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.cpnomecompleto">{{msgerror.cpnomecompleto}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="control-label">CPF</label>
                            <input name="iCpf" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'###.###.###-##'" 
                                   v-model="cpcpf"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.cpcpf">{{msgerror.cpcpf}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="control-label">Data de Nascimento</label>
                            <input name="iNascimento" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'##/##/####'" 
                                   v-model="cpdatanascimento" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.cpdatanascimento">{{msgerror.cpdatanascimento}}</span>
                          </div>
                        </div>
                      </div>
                    </div>


                     <!-- ================================================= -->
                    <!-- IDENTIFICACAO: EMAIL, CONF EMAIL E TELEFONE  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-5">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">E-mail</label>
                            <input name="iEmail" 
                                   type="text" 
                                   class="form-control"
                                   autocomplete="nope" 
                                   v-model="cpemail" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.cpemail">{{msgerror.cpemail}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="">
                          <div class="form-group label-floating is-empty">
                            <label class="control-label">Confirma seu e-mail</label>
                            <input name="iEmailC" 
                                   type="text" 
                                   class="form-control"
                                   autocomplete="nope" 
                                   v-model="cpconfirmaemail"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.cpconfirmaemail">{{msgerror.cpconfirmaemail}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="control-label">Telefone</label>
                            <input name="iTelefone" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'(##) # #### ####'" 
                                   v-model="cptelefone"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.cptelefone">{{msgerror.cptelefone}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ====================== -->
                <!-- RESUMO: INICIO  -->
                <!-- ====================== -->
                <div class="tab-pane" id="description">
                  <div class="row">
                  
                  
                    <!-- ======================= -->
                    <!-- RESUMO: TITULO       -->
                    <!-- ======================= -->
                    <div class="col-sm-12">
                      <h4 class="info-text">
                        <strong>Resumo</strong>
                      </h4>
                    </div>
                    
                    <!-- ================================================= -->
                    <!-- RESUMO: NUMERO PEDIDO  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-12">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <label class="control-label">Número do pedido</label>
                            <input name="rNumeroPedido" 
                                   type="tel" 
                                   class="form-control"
                                   :value="pedidoResponse.pedido+' '"
                                   disabled="true"
                                   autocomplete="nope" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>  
                    </div>

                    <!-- ================================================= -->
                    <!-- RESUMO: ITEM PEDIDO E PARCELA  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <label class="control-label">Itens do Pedido</label>
                            <input name="rItem" 
                                   type="text" 
                                   class="form-control"
                                    :value="pedidoResponse.itemPedido+' '"
                                   disabled="true"
                                   autocomplete="nope" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <!-- <label class="control-label">{{parcelas.quantity}}x de R$ {{parcelas.installmentAmount}} {{parcelas.interestFree ? '(sem juros)' : '(com juros)' }}</label> -->
                            <label class="control-label">1x de R$ {{pedidoResponse.valorTotal.toFixed(2)}} (sem juros)</label>
                            <input name="rPagar" 
                                   type="text" 
                                   class="form-control"
                                   :value="'Total a pagar: R$ ' + pedidoResponse.valorTotal.toFixed(2)"
                                   disabled="true"
                                   autocomplete="nope" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <label class="control-label">Forma de pagamento</label>
                            <input name="rForma" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   disabled="true"
                                   :value="pedidoResponse.formaPagamento+' '" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="input-group">
                          <div class="form-group" style="background-color: #c8c8c833; border-radius: 10px; padding: 10px;">
                            {{pedidoResponse.mensagem}}                          
                          </div>
                        </div>
                      </div>

                    </div>

                  
                  </div> 
                </div>
              </div>
              
              <div class="wizard-footer">
	              <div class="pull-right">
	                <input type="button" class="btn btn-next btn-fill btn-wd btn-info" name="next" value="Próximo" style="" >
	                <input type="button" @click="getCardTokenAndSendRequest()" class="btn btn-finish btn-fill btn-wd btn-info" name="finish" value="Finalizar" style="display: none;">
	              </div>
	              <div class="pull-left">
	                <input type="button" class="btn btn-previous btn-fill btn-default btn-wd disabled" name="previous" value="Voltar">
	              </div>
	              <div class="clearfix"></div>
	            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="container text-center">
       By <a href="javascript:void(0);" @click="abrirSiteCliqx()">cliqx.com.br</a>
    </div>
    <!-- 
    <button class="btn btn-block btn-primary" data-toggle="modal" data-target="#modalEnderecoCobranca">
      <i class="material-icons">library_books</i>
        Classic
    </button>
    -->
  </div>


  <!-- ============================ -->
  <!-- MODAL: ENDEREÇO DE COBRANÇA  -->
  <!-- ============================ -->
  <div class="modal fade" id="modalEnderecoCobranca" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" style="display: none">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="material-icons">clear</i>
          </button>
        </div>
        <div class="modal-body" >
          <div class="tab-pane" id="captain">
            <div class="row">
              <div class="col-sm-12">
                <h4 class="info-text" style="text-align: -webkit-center;" >
                  <strong>Endereço de cobrança</strong>
                </h4>
              </div>
              <div class="row" style="padding-left: 25px; padding-right: 25px;">
                <div class="col-sm-12">
                  <div class="input-group">
                    <div class="form-group label-floating is-empty">
                      <label class="control-label">Cep</label>
                        <input name="mpgcep" type="tel" class="form-control color-blue-focus" autocomplete="nope" v-maska="'#####-###'" v-model="pgcep" required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgcep">{{msgerror.pgcep}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="">
                        <div class="form-group label-floating is-empty">
                          <label class="control-label">Endereço</label>
                          <input name="mpgendereco" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgendereco" required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgendereco">{{msgerror.pgendereco}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="">
                        <div class="form-group label-floating is-empty">
                          <label class="control-label">N°</label>
                          <input name="mpendereconumero" type="tel" class="form-control color-blue-focus" autocomplete="nope" v-model="pgendereconumero"  required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgendereconumero">{{msgerror.pgendereconumero}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="">
                        <div class="form-group label-floating is-empty">
                          <label class="control-label">Complemento</label>
                          <input name="pmenderecocomplemento" type="tel" class="form-control color-blue-focus" autocomplete="nope" v-maska="'##/##/####'" v-model="pgenderecocomplemento"  required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgenderecocomplemento">{{msgerror.pgenderecocomplemento}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="">
                        <div class="form-group label-floating is-empty">
                          <label class="control-label">Bairro</label>
                          <input name="pmbairro" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgbairro"  required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgbairro">{{msgerror.pgbairro}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="">
                        <div class="form-group label-floating is-empty">
                          <label class="control-label">Cidade</label>
                          <input name="pmcidade" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgcidade"  required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgcidade">{{msgerror.pgcidade}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="">
                        <div class="form-group label-floating is-empty">
                          <label class="control-label">Estado</label>
                          <input name="pmestado" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgestado"  required />
                          <span class="material-input"></span>
                          <span class="error" v-if="msgerror.pgestado">{{msgerror.pgestado}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="border-top: none;">
              <button type="button" class="btn btn-next btn-fill btn-wd btn-info" data-dismiss="modal">Concluir</button>
            </div>
      </div>
    </div>
  </div>

  <!-- =========================== -->
  <!-- MODAL: TRANSAÇÃO REALIZADA  -->
  <!-- =========================== -->
  <div class="modal fade" id="modalTransacaoRealizada" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" style="border-bottom: none;">
          <!--
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="material-icons">clear</i>
          </button>
          -->
        </div>
        <div class="modal-body">

          <div class="col-sm-12" style="margin-bottom: 2rem; margin-top: -10px;">
            <h4 class="info-text" style="text-align: -webkit-center;" >
              <strong>Compra concluída!</strong>
            </h4>
          </div>
          
          <div>
            <p><strong>Nº do pedido:</strong> {{statusPagamentoResponse.pedido}}</p>
            <p><strong>Data transação:</strong> {{statusPagamentoResponse.datatransacao}}</p>
            <p><strong>Status pagamento</strong> {{statusPagamentoResponse.pagamento}}</p>
            <p><strong>Forma de pagamento:</strong> Cartão de crédito</p>
            <p><strong>Valor total:</strong> R$ {{statusPagamentoResponse.valor.toFixed(2)}}</p>
          </div>
          
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import { maska } from 'maska';

import Pagamento      from '../model/Pagamento.js';
import Parcelas       from '../model/Parcelas.js';
import Comprador      from '../model/Comprador.js';
import PedidoResponse from '../model/PedidoResponse.js';
import Service        from '../services/Api.js';
import Loading        from '../components/Loading/index.vue'; 

export default {

  directives: { maska },
  components: { Loading },

  /* props: [ 'pedidoResponse'],*/
  props: {pedidoResponse: PedidoResponse},
  data: () => ({ 

    pagamento: Pagamento,
    parcelas: Parcelas,
    comprador: Comprador,
    parcelasLista: [],
    showLoading: false,

    statusPagamentoResponse: {
      status: '',
      pagamento: '',
      datatransacao: '',
      valor: 0,
      pedido: '',
    },

    pgSenderHash: '',
   
    msgerror: [],
    pgnumerocartao: '',
    pgvalidadecartao: '',
    pgcvvcartao: '',
    pgnomecompleto: '',
    pgdatanascimento: '',
    pgcpf: '',
    pgtelefone: '',
    pgcep: '',
    
    cpnomecompleto: ' ',
    cpcpf: ' ',
    cpdatanascimento: ' ',
    cpemail: '',
    cpconfirmaemail: '',
    cptelefone: ' ',
    
    teste: false

  }),

  created(){
    this.pagamento = new Pagamento()
    this.parcelas  = new Parcelas()
    this.comprador = new Comprador()
  },
  
  watch: {
    pgnumerocartao:   function(newValue, oldValue){ this.validaPagadorCartaoNumero(newValue) },
    pgvalidadecartao: function(newValue, oldValue){ this.validaPagadorCartaoValidade(newValue) },
    pgcvvcartao:      function(newValue, oldValue){ this.validaPagadorCartaoCvv(newValue) },
    pgnomecompleto:   function(newValue, oldValue){ this.validaPagadorCartaoNomeCompleto(newValue) },
    pgdatanascimento: function(newValue, oldValue){ this.validaPagadorDataNascimento(newValue) },
    pgcpf:            function(newValue, oldValue){ this.validaPagadorCpf(newValue) },
    pgtelefone:       function(newValue, oldValue){ this.validaPagadorTelefone(newValue) },
    pgcep:            function(newValue, oldValue){ this.validaPagadorCep(newValue) },

    cpnomecompleto:   function(newValue, oldValue){ this.validaCompradorNome(newValue) },
    cpcpf:            function(newValue, oldValue){ this.validaCompradorCpf(newValue) },
    cpdatanascimento: function(newValue, oldValue){ this.validaCompradorDatanascimento(newValue) },
    cpemail:          function(newValue, oldValue){ this.validaCompradorEmail(newValue) },
    cpconfirmaemail:  function(newValue, oldValue){ this.validaCompradorConfirmarEmail(newValue) },
    cptelefone:       function(newValue, oldValue){ this.validaCompradorTelefone(newValue) },

  },
  
  methods: {

      abrirSiteCorreio: function(){
        window.open("https://buscacepinter.correios.com.br/app/endereco/index.php", "_blank");    
      },

      abrirSiteCliqx: function(){
        window.open("https://cliqx.com.br", "_blank");    
      },

      abrirSiteCliente: function(){
        window.open("https://www.urbs.curitiba.pr.gov.br", "_blank");
      },

      validShowinstallment: function(){
        if(this.pagamento.cardBrand === null || this.pagamento.cardBrand.trim() === ""){
          alert('Para visualizar a parcelas, informe os 6 primeiros digitos do cartão')
          return;
        }
      },


      addHashSender: function(){
        this.pgSenderHash = '';
        let self = this;
        PagSeguroDirectPayment.onSenderHashReady(function(response){
            if(response.status == 'error') {
              console.log("Error hash" + response.message);
              return false;
            }
            self.pgSenderHash = response.senderHash;
            //console.log(self.pgSenderHash);
        })
      },

      getCardBrand: function(){
      
      if(this.pagamento.cardNumber === null)  return
      if(this.pagamento.cardNumber.trim().split(" ").length < 2) return
      
      const cardNumber = this.pagamento.cardNumber.split(" ")[0] + this.pagamento.cardNumber.split(" ")[1]  

      if(cardNumber.length != 6 ) return;

      let self = this;
      PagSeguroDirectPayment.getBrand({
				cardBin: cardNumber.substring(0,6),
				success: function(response) { 
						//console.log(response);
            self.pagamento.cardBrand    = response['brand']['name'];
            self.pagamento.cardCvvSize  = response['brand']['cvvSize'];
            self.getCardinstallment();
            self.addHashSender();
				},
				error: function(response) { console.log(response); }
			 })  

    },


    getCardinstallment: function(){
      let self = this;
      PagSeguroDirectPayment.getInstallments({
			  amount: self.pedidoResponse.valorTotal.toString().replace(",", "."),
			  brand:  self.pagamento.cardBrand,
			  maxInstallmentNoInterest: 2, //calculo de parcelas sem juros
			  success: function(response) {
          console.log(response);
          console.log(response['installments'])
          self.parcelasLista  = response['installments'][self.pagamento.cardBrand];
          self.parcelas       = self.parcelasLista[0];
			  },
			  error: function(response) { console.log(response); }
		  })
    },

     getCardTokenAndSendRequest: function(){
       
      if(this.pagamento.cardNumber === null || this.pagamento.cardNumber.length != 19) 
        return;
      
      if(this.pagamento.cardDataValidate === null || this.pagamento.cardDataValidate.length != 5) 
        return;
      
      if(this.pagamento.cardCvv === null && this.pagamento.cardCvv.length != 3)
        return;

      this.showLoading = true;
      let card = this.pagamento.cardNumber.split(" ");
      let cvv  = this.pagamento.cardCvv.trim();
      let date = this.pagamento.cardDataValidate.split("/");
      let self = this;
      console.log("Cartao:"+card[0].trim()+card[1].trim()+card[2].trim()+card[3].trim());
      console.log("Cvv:"+cvv);
      console.log("Data:"+date);
      console.log("Mes:"+date[0].trim());
      console.log("Ano:20" + date[1].trim());
      var param = {
        cardNumber: card[0].trim() + card[1].trim() + card[2].trim() + card[3].trim(),
        cvv: cvv,
        expirationMonth: date[0].trim() ,
        expirationYear: "20" + date[1].trim(),
        success: function(response) {
          //console.log(response);
          //console.log(response['card']['token']);
          self.pagamento.cardToken = response['card']['token'];
          //console.log(self.paymentData);
          self.pvtSendPayment();
        },
        error: function(response) { console.log(response); printError(response); this.showLoading = false; }
		  }

      PagSeguroDirectPayment.createCardToken(param);
    },

    
    pvtSendPayment: function(){
      const self = this;
      const obj = {
                    "token":this.pagamento.cardToken,"hash":this.pgSenderHash,"uuid":this.$route.params.uuid,
                    "payer":{"name":this.pagamento.ownerFullname,"cpf":this.pagamento.ownerCpf,"phone":this.pagamento.ownerPhone ,"dtBirth":this.pagamento.ownerDateBirth, "qtnInstallments":1,"valueAmount":this.pedidoResponse.valorTotal, "valueInstallmentAmount": this.pedidoResponse.valorTotal},
                    "buyer":{"name":this.comprador.fullName, "dtBirth":this.comprador.dateBirth, "cpf":this.comprador.cpf ,"phone":this.comprador.phone,"email":this.comprador.email }
                  }

      let data = JSON.stringify(obj);
      Service.enviaCheckout(data).then(response => {
        //console.log(response)
        self.statusPagamentoResponse = response.data;
        this.showLoading = false;
        $('#modalTransacaoRealizada').modal('show')
        
      }).catch( error => {
        this.showLoading = false;
        console.log(error)
        alert('Pagamento não aprovado.');
      })
    },


    /***
    * METODOS PARA VALIDAÇÃO \;
    */
    validaPagadorCartaoNumero: function(novoValor){
      this.pagamento.cardNumber = novoValor;
      const isValid = novoValor.length === 19;
      if(isValid){
        this.msgerror['pgnumerocartao'] = '';
        return;
      }
      this.msgerror['pgnumerocartao'] = 'Informe os 16 digitos do cartão';
     },

    validaPagadorCartaoValidade: function(novoValor){ 
      this.pagamento.cardDataValidate = novoValor;
      const isValid = novoValor.length === 5;
      if(isValid){
        this.msgerror['pgvalidadecartao'] = '';
        return;
      }
      this.msgerror['pgvalidadecartao'] = 'Informe no formato MM/AA';
    },

    validaPagadorCartaoCvv: function(novoValor){
      this.pagamento.cardCvv = novoValor;
      const isValid = novoValor.length === 3;
      if(isValid){
         this.msgerror['pgcvvcartao'] = ''
         return;
      }
      this.msgerror['pgcvvcartao'] = 'Informe codigo de segurança';
    },

    validaPagadorCartaoNomeCompleto: function(novoValor){ 
      this.pagamento.ownerFullname  = novoValor;
      this.comprador.fullName       = novoValor;
      this.cpnomecompleto           = novoValor;
      console.log("comprador nome " + this.comprador.fullName);
      const isValid = novoValor.trim().split(" ").length > 1;
      if(isValid){
        this.msgerror['pgnomecompleto'] = '';
        return;
      }
      this.msgerror['pgnomecompleto'] = 'Informe o nome conforme está no cartão';
    },

    validaPagadorDataNascimento: function(novoValor){ 
      this.pagamento.ownerDateBirth = novoValor;
      this.comprador.dateBirth      = novoValor;
      this.cpdatanascimento         = novoValor;
       console.log("comprador nacimento " + this.comprador.dateBirth);
      const isValid = novoValor.length === 10;
      if(isValid){
        this.msgerror['pgdatanascimento'] = '';
        return;  
      }
      this.msgerror['pgdatanascimento'] = 'Informe no formato DD/MM/AAAA';
    },

    validaPagadorCpf: function(novoValor){ 
      this.pagamento.ownerPhone = novoValor;
      this.comprador.cpf        = novoValor;
      this.cpcpf                = novoValor;
      console.log("comprador cpf " + this.comprador.cpf);
      const isValid = novoValor.length === 14;
      if(isValid){
        this.msgerror['pgcpf'] = '';
        return;
      }
      this.msgerror['pgcpf'] = 'Informe os 11 digitos do CPF';
    },

    validaPagadorTelefone: function(novoValor){ 
      this.pagamento.ownerPhone = novoValor;  
      this.comprador.phone      = novoValor;  
      this.cptelefone           = novoValor;
      console.log("comprador phone " + this.comprador.phone);
      const isValid = novoValor.length === 16 ;
      if(isValid){
        this.msgerror['pgtelefone'] = '';
        return;
      }
      this.msgerror['pgtelefone'] = 'Informe seu telefone com DDD';
    },

    validaPagadorCep: function(novoValor){ 
      this.pagamento.ownerCep = novoValor;    
      const isValid = novoValor.length === 9;
      if(isValid){
        this.msgerror['pgcep'] = '' ;
        return; 
      }
      this.msgerror['pgcep'] = 'Informe os 8 digitos de seu CEP';
    },

    validaCompradorNome: function(novoValor){ 
      this.comprador.fullName = novoValor;
      const isValid = novoValor.trim().split(" ").length > 1;
      if(isValid){
        this.msgerror['cpnomecompleto'] = '';
        return;  
      }
      this.msgerror['cpnomecompleto'] = 'Informe o seu nome completo';
    },

    validaCompradorCpf: function(novoValor){ 
      this.comprador.cpf = novoValor;
      const isValid = novoValor.length === 14;
      if(isValid){
         this.msgerror['cpcpf'] = '';
         return;
      }
      this.msgerror['cpcpf'] = 'Informe os 11 digitos do CPF';
    },

    validaCompradorDatanascimento: function(novoValor){ 
      this.comprador.dateBirth = novoValor;
      const isValid = novoValor.length === 10;
      if(isValid){
        this.msgerror['cpdatanascimento'] = ''
        return;
      }
      this.msgerror['cpdatanascimento'] = 'Informe no formato DD/MM/AAAA';
    },

    validaCompradorEmail: function(novoValor){
      this.comprador.email = novoValor;
      const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(novoValor); 
      if(isValid){
        this.msgerror['cpemail'] = ''  
        return;
      }
      this.msgerror['cpemail'] = 'Informe um email valido';
    },

    validaCompradorConfirmarEmail: function(novoValor){ 
      this.comprador.confirmEmail = novoValor;
      const isValid = novoValor === this.cpemail;
      if(isValid){
        this.msgerror['cpconfirmaemail'] = '';
        return;
      }
      this.msgerror['cpconfirmaemail'] = 'Deve ser igual oa que está no campo email';
    },

    validaCompradorTelefone: function(novoValor){
      this.comprador.phone = novoValor;
      const isValid = novoValor.length === 16; 
      if(isValid){
        this.msgerror['cptelefone'] = '';
        return;
      }
      this.msgerror['cptelefone'] = 'Informe seu telefone com DDD';
    },
    

        
   }

}

</script>
<style>

</style>
